type PwdVerifier = (password: string) => boolean;

export const isPwdLong: PwdVerifier = (password) => {
  return password.length > 7;
};

export const hasSpecialChar: PwdVerifier = (password) => {
  /* eslint-disable no-useless-escape */
  const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return format.test(password);
};

const isPasswordValid: PwdVerifier = (password) => {
  return isPwdLong(password) && hasSpecialChar(password);
};

export default isPasswordValid;
